import { atomWithDefault } from "jotai/utils";
import { getStoreDb } from "./store.service";
import { atom } from "jotai";

export const baseStoreDbAtom = atomWithDefault(async () => await getStoreDb());

export const storeDbAtom = atom(
  async (get) => await get(baseStoreDbAtom),
  (_get, set, update) => {
    set(baseStoreDbAtom, update);
  }
);
